<template>
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1254_7221)">
      <path
        d="M4.5 8H25.5C26.8333 8 27.5 8.66667 27.5 10V28.5C27.5 29.8333 26.8333 30.5 25.5 30.5H4.5C3.16667 30.5 2.5 29.8333 2.5 28.5V10C2.5 8.66667 3.16667 8 4.5 8Z"
        fill="#111314"
        fill-opacity="0.72"
      />
      <path
        d="M30 8H0L1.52 1.92C1.62145 1.51442 1.85554 1.15438 2.18508 0.8971C2.51461 0.639816 2.92068 0.500046 3.33875 0.5L26.6625 0.5C27.0806 0.500046 27.4866 0.639816 27.8162 0.8971C28.1457 1.15438 28.3798 1.51442 28.4812 1.92L30 8Z"
        fill="#EDEEF0"
      />
      <path
        d="M30 8C30 8.99456 29.6049 9.94839 28.9016 10.6517C28.1984 11.3549 27.2446 11.75 26.25 11.75C25.0487 11.75 23.945 10.8025 22.9412 8.90875C22.8986 8.82875 22.835 8.76185 22.7573 8.7152C22.6796 8.66855 22.5906 8.64391 22.5 8.64391C22.4094 8.64391 22.3204 8.66855 22.2427 8.7152C22.165 8.76185 22.1014 8.82875 22.0588 8.90875C21.055 10.8025 19.95 11.75 18.75 11.75C17.5487 11.75 16.445 10.8025 15.4412 8.90875C15.3986 8.82875 15.335 8.76185 15.2573 8.7152C15.1796 8.66855 15.0906 8.64391 15 8.64391C14.9094 8.64391 14.8204 8.66855 14.7427 8.7152C14.665 8.76185 14.6014 8.82875 14.5588 8.90875C13.555 10.8025 12.45 11.75 11.25 11.75C10.0487 11.75 8.945 10.8025 7.94125 8.90875C7.89862 8.82875 7.83504 8.76185 7.75732 8.7152C7.67959 8.66855 7.59065 8.64391 7.5 8.64391C7.40935 8.64391 7.32041 8.66855 7.24268 8.7152C7.16496 8.76185 7.10138 8.82875 7.05875 8.90875C6.055 10.8025 4.95 11.75 3.75 11.75C2.75544 11.75 1.80161 11.3549 1.09835 10.6517C0.395088 9.94839 0 8.99456 0 8H30Z"
        fill="#CACBCC"
      />
      <path
        d="M6 13H24C24.6667 13 25 13.3333 25 14V27C25 27.6667 24.6667 28 24 28H6C5.33333 28 5 27.6667 5 27V14C5 13.3333 5.33333 13 6 13Z"
        fill="white"
      />
      <path d="M18.75 13H20V14.25H18.75V13Z" fill="#CACBCC" />
      <path
        d="M17.25 14.25H21.5C21.6313 14.25 21.7614 14.2759 21.8827 14.3261C22.004 14.3764 22.1142 14.45 22.2071 14.5429C22.3 14.6358 22.3736 14.746 22.4239 14.8673C22.4741 14.9886 22.5 15.1187 22.5 15.25V17C22.5 17.2652 22.3946 17.5196 22.2071 17.7071C22.0196 17.8946 21.7652 18 21.5 18H17.25C16.9848 18 16.7304 17.8946 16.5429 17.7071C16.3554 17.5196 16.25 17.2652 16.25 17V15.25C16.25 15.1187 16.2759 14.9886 16.3261 14.8673C16.3764 14.746 16.45 14.6358 16.5429 14.5429C16.6358 14.45 16.746 14.3764 16.8673 14.3261C16.9886 14.2759 17.1187 14.25 17.25 14.25ZM5 23H16.5C16.7652 23 17.0196 23.1054 17.2071 23.2929C17.3946 23.4804 17.5 23.7348 17.5 24V28H6C5.86868 28 5.73864 27.9741 5.61732 27.9239C5.49599 27.8736 5.38575 27.8 5.29289 27.7071C5.20003 27.6142 5.12637 27.504 5.07612 27.3827C5.02587 27.2614 5 27.1313 5 27V23Z"
        fill="#EDEEF0"
      />
      <path
        d="M8 19.25H9.5C9.775 19.25 10 19.475 10 19.75V23H7.5V19.75C7.5 19.475 7.725 19.25 8 19.25Z"
        fill="#5BADFF"
      />
      <path
        d="M25.7863 29.115C25.7411 29.1531 25.684 29.174 25.625 29.174C25.566 29.174 25.5089 29.1531 25.4637 29.115C22.655 26.7438 21.25 24.8188 21.25 23.34C21.25 21.0825 23.2088 19.25 25.625 19.25C28.0413 19.25 30 21.0813 30 23.3413C30 24.8188 28.595 26.7438 25.7863 29.115ZM25.7412 25.25C26.9225 25.25 27.88 24.355 27.88 23.25C27.88 22.145 26.9225 21.25 25.7425 21.25C24.56 21.25 23.6025 22.145 23.6025 23.25C23.6025 24.355 24.56 25.25 25.7412 25.25Z"
        fill="#FFC13C"
      />
    </g>
    <defs>
      <clipPath id="clip0_1254_7221">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconMenuPos',
} as DefineComponent
</script>
